import { formatPrice } from '@websrc/App/Helpers/formatting'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { mapProductPage } from '@websrc/DataMappers/mapProductPage'
import clsx from 'clsx'
import { styles, typography } from 'leds'
import React from 'react'

interface ProductInfoPriceProps {
  productDetails: Pick<
    ReturnType<typeof mapProductPage>['product_details'],
    'price_list' | 'is_retired' | 'price_discount'
  >
  show?: boolean
  textSize?: 'xs' | 'xl2' | 'xl3' | 'xl4'
  className?: string
}

export const ProductInfoPrice: React.FC<ProductInfoPriceProps> = ({
  productDetails,
  show,
  textSize = 'xl4',
  className,
}) => {
  const locale = useLocale()

  const { price_list, price_discount, is_retired } = productDetails

  if (locale !== 'en-us' || is_retired || !show) {
    return null
  }

  const isDiscounted = price_discount !== price_list

  return (
    <div className={clsx(styles({ display: 'flex' }), className)}>
      <p
        className={clsx(
          styles({ textDecoration: isDiscounted ? 'line-through' : undefined }),
          typography({ size: textSize })
        )}
      >
        {formatPrice(price_list)}
      </p>
      {isDiscounted && (
        <p
          className={clsx(typography({ size: textSize }), styles({ marginLeft: 20 }))}
          style={{ color: '#00a843' }}
        >
          {formatPrice(price_discount)}
        </p>
      )}
    </div>
  )
}
